const marketing = {
  bookDemoLink: 'https://cal.com/trycedar/demo',
};
export default marketing;
